<template>
  <div
    :class="{ selected: batch.loteId === selectedBatch }"
    class="row p-3 mt-2 shadow-sm bg-white"
  >
    <div class="col-11">
      <div class="row">
        <div class="col-2 text-center text-primary">
          <div
            data-cy="file-number"
            v-tooltip="'Folio Lote'"
            :class="{ 'text-success': wasCopied }"
            class="cursor-pointer"
            @click="copyToClipboard(batch.loteId, batch.folio)"
          >
            {{ batch.folio }}
          </div>
          <b-form-checkbox
            v-model="batch.selected"
            @change="selectElement"
            data-cy="select"
          />
        </div>
        <div class="col-2">
          <b-badge
            pill
            :variant="batchesStates[batch.estado].color"
            v-if="batchesStates[batch.estado]"
            v-tooltip="`${batchesStates[batch.estado].label}`"
            class="p-2 font-weight-light"
          >
            {{batchesStates[batch.estado].label}}
          </b-badge>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-4">
              {{ batch.loteadoraValor || '-' }}
            </div>
            <div class="col-2">
              <span v-if="batch.requiereVb == '0'">
                No
              </span>
              <span v-if="batch.requiereVb == '1'">
                Si
              </span>
            </div>
            <div class="col-2">
              <span v-if="batch.esExLote == IS_EXISTING_BATCH">
                Si
              </span>
              <span v-if="batch.esExLote == IS_NOT_EXISTING_BATCH">
                No
              </span>
            </div>
            <div class="col-3">
              {{ batch.calidadJuridicaNombre || '-'}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-11 offset-1">
          <vs-chip
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Monto Mínimo'"
            v-if="batch.montoMinimo"
          >
            <vs-avatar icon="monetization_on" />
            {{ batch.montoMinimo | amount}}
          </vs-chip>
          <vs-chip color="#ff9800" class="mr-4" v-tooltip="'Fecha de Emisión'">
            <vs-avatar icon="date_range" />
            {{ batch.fechaCreacion | dateFormat}}
          </vs-chip>
          <vs-chip color="primary" class="mr-4" v-tooltip="'Usuario Creador'">
            <vs-avatar icon="person" />
            {{ batch.usuarioNombre || '-'}}
          </vs-chip>
          <vs-chip
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Subasta Asociada'"
            v-if="batch.subasta"
          >
            <vs-avatar icon="gavel" />
            {{ batch.subasta.folio }}
          </vs-chip>
          <vs-chip
            class="mr-4"
            color="primary"
            v-tooltip="'Posición Subasta'"
            v-if="showPositionInfo"
          >
            <vs-avatar icon="location_on" />
            {{
              `${batch.loteadora.codigo}
              -${batch.subasta.gestora.codigoAduana}
              -${batch.folio}
              -${batch.posicion}`
            }}
          </vs-chip>
          <vs-chip
            v-if="batch.devolucionesCantidad > 0"
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Número de devoluciones'"
          >
            <vs-avatar icon="replay" />
            {{batch.devolucionesCantidad}}
          </vs-chip>
        </div>
      </div>
    </div>
    <div class="col-1 d-flex justify-center">
      <slot name="actions" v-bind:batch="batch">
        <BatchesOptions
          :ref="'file-options-' + batch.id"
          :batch="batch"
          :select-batch="selectBatch"
          v-on:reload-list="handleReloadList"
        />
      </slot>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import BatchesOptions from '@/febos/aduanas/batches/views/components/BatchesOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import { batchesStates, IS_EXISTING_BATCH, IS_NOT_EXISTING_BATCH } from '@/febos/aduanas/batches/views/utils/constants';

export default {
  components: { BatchesOptions },
  mixins: [CopyToClipboard],
  data() {
    return {
      batchesStates,
      IS_EXISTING_BATCH,
      IS_NOT_EXISTING_BATCH
    };
  },
  props: [
    'batch',
    'selectBatch',
    'isMassive',
    'selectedBatches'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('batches', ['selectedBatch']),
    showPositionInfo() {
      return (this.batch.posicion
        && this.batch.subasta
        && this.batch.subasta.gestora
        && this.batch.loteadora.codigo);
    },
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    selectElement() {
      if (this.batch.selected) {
        this.$emit('select-check-batch', this.batch);
        return;
      }
      this.$emit('unselect-check-batch', this.batch);
    },
    handleReloadList() {
      this.$emit('reload-list');
    }
  }
};
</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
.mother-indicator {
  width: 160px;
  margin-left: 50%;
  left: 80px;
}
</style>
